var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useCallback, useContext, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import { TestVersionBanner } from './TestVersionBanner';
var PreLoginBannerContext = createContext(null);
/**
 * Places the test-version banner on the pre-login screens.
 *
 * Pages that show the organization logo get the banner directly under the logo
 * (between the logo and the form, see {@link PreLoginLogoBanner}); pages without
 * a logo keep it full-width at the top. Either way it is rendered exactly once.
 */
export var PreLoginBannerProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), logoIds = _b[0], setLogoIds = _b[1];
    var registerLogo = useCallback(function (logoId) {
        setLogoIds(function (ids) { return __spreadArray(__spreadArray([], ids, true), [logoId], false); });
        return function () { return setLogoIds(function (ids) { return ids.filter(function (id) { return id !== logoId; }); }); };
    }, []);
    var bannerOwnerId = logoIds.length > 0 ? logoIds[0] : null;
    var value = useMemo(function () { return ({ registerLogo: registerLogo, bannerOwnerId: bannerOwnerId }); }, [registerLogo, bannerOwnerId]);
    return (React.createElement(PreLoginBannerContext.Provider, { value: value },
        bannerOwnerId === null && React.createElement(TestVersionBanner, null),
        children));
};
var nextLogoId = 0;
/**
 * Rendered right after the organization logo. Inside {@link PreLoginBannerProvider}
 * it shows the banner sized to the login column; outside of it (e.g. the
 * authenticated shell, which has its own banner below the main navigation) it
 * renders nothing.
 */
export var PreLoginLogoBanner = function () {
    var context = useContext(PreLoginBannerContext);
    var logoId = useRef();
    if (logoId.current === undefined) {
        nextLogoId += 1;
        logoId.current = nextLogoId;
    }
    var registerLogo = context === null || context === void 0 ? void 0 : context.registerLogo;
    // Layout effect: the banner moves from the top to under the logo before the first paint.
    useLayoutEffect(function () { return registerLogo === null || registerLogo === void 0 ? void 0 : registerLogo(logoId.current); }, [registerLogo]);
    if (!context || context.bannerOwnerId !== logoId.current)
        return null;
    return React.createElement(TestVersionBanner, { placement: "inline" });
};
